/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
/**
 * Represents the content template of the declaratively initialized PanelBar items.
 * The content can be expanded or collapsed through the item.
 */
var PanelBarContentDirective = /** @class */ (function () {
    function PanelBarContentDirective(templateRef) {
        this.templateRef = templateRef;
    }
    PanelBarContentDirective = tslib_1.__decorate([
        core_1.Directive({
            selector: "[kendoPanelBarContent]"
        }),
        tslib_1.__metadata("design:paramtypes", [core_1.TemplateRef])
    ], PanelBarContentDirective);
    return PanelBarContentDirective;
}());
exports.PanelBarContentDirective = PanelBarContentDirective;
